export default class messageFlowEndpoint {
    constructor($timeout) {
        return {
            restrict: 'E',
            scope: {
                type: '=',
                label: '=',
                membersDiff: '=',
                noBorder: '='
            },
            template: require("../../../../views/directives/message-flow-endpoint.html"),
            controller: ['$scope', ($scope) => {
            }]
        }
    }
};